<div class="row h-100">
  <section
    class="col-sm-12 col-lg-6 col-md-6 super-compos-left-shadow"
    [ngClass]="{ 'col-lg-12 col-md-12': !mailMode || mailMode === 'duplicate' }"
    [class]="fullscreenMode ? 'hideSection' : ''">
    <div class="row mt-2">
      <div class="col-md-12">
        @if (!mailMode) {
          <i-title
            [text]="titleDisplayed"
            pTooltip="{{ currentCourrier?.objet ?? 'Courrier sans objet' }}"
            tooltipPosition="bottom"
            hasBackIcon="true"
            [iconTooltip]="'back' | translate"
            (iconClick)="back()"
            [buttons]="noMailModeButtons"></i-title>
        }
        @if (mailMode) {
          <i-title
            [text]="titleDisplayed"
            pTooltip="{{ currentCourrier?.objet ?? 'Courrier sans objet' }}"
            tooltipPosition="bottom"
            hasBackIcon="true"
            [iconTooltip]="'back' | translate"
            (iconClick)="back()"
            [buttons]="mailModeButtons"></i-title>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-md-12" style="overflow-y: auto; max-height: 90vh">
        @if (allDataSetToLoad) {
          <app-courrier-edition-form
            [duplicatedMailIdFromiScan]="duplicatedMailId"
            [scan]="scan"
            [mail]="mail"
            [mailType]="typeEntranSortant"
            (isFormValid)="receiveFormValidSt($event)"
            [serviceProprietaireId]="scan?.file?.serviceProprietaireId"
            [globalSubmitE]="globalSubmitESubject.asObservable()"
            (canSubmit)="canSubmitReceived($event)"
            (formChange)="onFormChangeEvent($event)"
            [mailId]="mailId"
            (newMail)="receiveNewMail($event)"
            (formState)="receiveFormState($event)"
            (linkIdEvent)="receiveLinkMailId($event)"
            [mailMode]="mailMode"
            [isDuplicateMode]="isDuplicateMode"
            (courrierIsSaved)="getCurrentUserLockInfoFromChildComponent($event)"
            (changeDestinataire)="checkDestinatairePrincipal($event)">
          </app-courrier-edition-form>
        }
      </div>
    </div>
  </section>

  <!-- Editor Mode  -->
  @if (mailMode !== 'duplicate') {
    <section class="col-sm-12 col-lg-6 col-md-6 answerMode" [class]="fullscreenMode ? 'fullWidth' : ''">
      <div>
        @switch (mailMode) {
          @case ('mailModel') {
            <div>
              @if (!selectedTemplate) {
                <div>
                  @if (currentCourrier?.typeEntrantSortant !== 'I' && hasMainDest === false) {
                    <div class="alert alert-info">
                      {{ 'createCourrier.chooseCreateMainRecipient' | translate }}
                    </div>
                  } @else {
                    <app-courrier-create-template-choice
                      [courrier]="currentCourrier"
                      (selectedValue)="receiveSelectedTemplate($event)"
                      [mailMode]="mailMode">
                    </app-courrier-create-template-choice>
                  }
                </div>
              }
              @if (selectedTemplate) {
                <div class="templateChoice w-100 h-100">
                  <app-document-editor
                    [isSaveMode]="isSaveMode"
                    [newMailId]="mailId"
                    [selectedTemplate]="selectedTemplate"
                    (currentFile)="receiveCurrentFile($event)">
                  </app-document-editor>
                </div>
              }
            </div>
          }
          @case ('mailNoModel') {
            <div>
              <app-document-editor [isSaveMode]="isSaveMode" [formInput]="formOutput" [newMailId]="mailId" (currentFile)="receiveCurrentFile($event)">
              </app-document-editor>
            </div>
          }
          @case ('emailnomodel') {
            <div>
              <app-document-editor
                [mailMode]="mailMode"
                [isSaveMode]="isSaveMode"
                [formInput]="formOutput"
                [newMailId]="mailId"
                (currentFile)="receiveCurrentFile($event)">
              </app-document-editor>
            </div>
          }
          @case ('emailmodel') {
            <div>
              @if (!selectedTemplate) {
                <div>
                  @if (currentCourrier?.typeEntrantSortant !== 'I' && hasMainDest === false) {
                    <div class="alert alert-info">
                      {{ 'createCourrier.chooseCreateMainRecipient' | translate }}
                    </div>
                  } @else {
                    <app-courrier-create-template-choice
                      [courrier]="currentCourrier"
                      (selectedValue)="receiveSelectedTemplate($event)"
                      [mailMode]="mailMode">
                    </app-courrier-create-template-choice>
                  }
                </div>
              }
              @if (selectedTemplate) {
                <div class="templateChoice w-100 h-100">
                  <app-document-editor
                    [isSaveMode]="isSaveMode"
                    [mailMode]="mailMode"
                    [formInput]="formOutput"
                    [selectedTemplate]="selectedTemplate"
                    [newMailId]="mailId"
                    (currentFile)="receiveCurrentFile($event)">
                  </app-document-editor>
                </div>
              }
            </div>
          }
          @case ('edit') {
            <div>
              @if (listOfFiles?.length) {
                <div class="templateChoice w-100 h-100">
                  <div class="mt-2 mb-2">
                    <i-title [text]="'global.selectFile' | translate"></i-title>
                  </div>
                  <div class="mb-3">
                    <p-dropdown
                      optionLabel="description"
                      optionValue="id"
                      [options]="listOfFiles"
                      [(ngModel)]="currentFileInDropdown"
                      (onChange)="changeFileToDisplay($event)"></p-dropdown>
                  </div>
                  @if (loadingFile) {
                    <div class="loader_div">
                      <i-loader [size]="100" [text]="'loading' | translate"></i-loader>
                    </div>
                  }
                  @if (!loadingFile) {
                    <div class="row">
                      @if (!isEmailFile) {
                        <div class="col-12 colReader" style="overflow: auto">
                          @if (!showOCR) {
                            <div>
                              @if (
                                currentFile?.extension &&
                                currentFile?.extension.toLowerCase() !== 'rtf' &&
                                currentFile?.extension.toLowerCase() !== 'txt' &&
                                currentFile?.extension.toLowerCase() !== 'pdf' &&
                                currentFile?.extension.toLowerCase() !== 'xlsx' &&
                                currentFile?.extension.toLowerCase() !== 'docx'
                              ) {
                                <span>
                                  <i-viewer [file]="currentFile"> </i-viewer>
                                </span>
                              }
                              @if (currentFile?.extension === 'xlsx') {
                                <span>
                                  @for (data of columnsExcel; track data; let index = $index) {
                                    <div>
                                      <h2 [ngClass]="{ 'mt-5': index > 0 }">{{ sheetNames[index] }}</h2>
                                      @if (columnsExcel && columnsExcel.length > 0 && excelData && excelData.length > 0) {
                                        <i-table
                                          [paginator]="true"
                                          class="super-table"
                                          [columns]="columnsExcel[index]"
                                          [items]="excelData[index]"
                                          id="excelforDatasFromExcelFileInModif{{ index }}"
                                          [multiselect]="false"
                                          [height]="'90vh'">
                                        </i-table>
                                      }
                                    </div>
                                  }
                                </span>
                              }
                              @if (
                                currentFile?.extension &&
                                (currentFile?.extension.toLowerCase() === 'rtf' ||
                                  currentFile?.extension.toLowerCase() === 'txt' ||
                                  currentFile?.extension.toLowerCase() === 'docx')
                              ) {
                                <span>
                                  <app-reader [currentFile]="cFile"></app-reader>
                                </span>
                              }
                              @if (currentFile?.extension && currentFile?.extension.toLowerCase() === 'pdf') {
                                <span>
                                  @if (currentFile) {
                                    <ngx-extended-pdf-viewer
                                      [src]="currentFile?.src"
                                      height="80vh"
                                      [zoom]="'auto'"
                                      [showFindButton]="true"
                                      [showPagingButtons]="true"
                                      [showZoomButtons]="true"
                                      [showPresentationModeButton]="true"
                                      [showOpenFileButton]="false"
                                      [showPrintButton]="false"
                                      [showDownloadButton]="false"
                                      [showSecondaryToolbarButton]="true"
                                      [showRotateButton]="true"
                                      [showHandToolButton]="true"
                                      [handTool]="false"
                                      [showScrollingButton]="true"
                                      [showSpreadButton]="false"
                                      [showPropertiesButton]="true"
                                      [customToolbar]="additionalButtonsTemplate"
                                      [(page)]="currentPage"
                                      (pageRendered)="pageRendered($event)">
                                    </ngx-extended-pdf-viewer>
                                  }
                                  <ng-template #additionalButtonsTemplate>
                                    <div id="toolbarViewer">
                                      <div id="toolbarViewerLeft">
                                        <pdf-toggle-sidebar></pdf-toggle-sidebar>
                                        <div class="toolbarButtonSpacer"></div>
                                        <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
                                        <pdf-paging-area></pdf-paging-area>
                                      </div>
                                      <div id="toolbarViewerRight">
                                        <pdf-presentation-mode></pdf-presentation-mode>
                                        <pdf-select-tool></pdf-select-tool>
                                        <pdf-rotate-page></pdf-rotate-page>
                                        <pdf-hand-tool></pdf-hand-tool>
                                        @if (currentFile) {
                                          <button
                                            type="button"
                                            class="toolbarButton new-tab hiddenMediumView"
                                            [title]="'createCourrier.fileOCR' | translate"
                                            (click)="openOCR()">
                                            <img src="./assets/img/decoration/ocr.png" alt="" />
                                          </button>
                                        }
                                        <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
                                      </div>
                                      <pdf-zoom-toolbar></pdf-zoom-toolbar>
                                    </div>
                                  </ng-template>
                                </span>
                              }
                            </div>
                          }
                          @if (showOCR) {
                            <div>
                              <div class="d-flex align-items-center justify-content-between">
                                <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'createCourrier.documentOCR' | translate }}</h5>
                                <div class="d-flex align-items-center mb-2">
                                  <i-button styleClass="red me-3" [text]="'createCourrier.stopOCR' | translate" (click)="showOCR = false"></i-button>
                                  <i-button styleClass="blue me-3" [text]="'createCourrier.ocr' | translate" (click)="startOCR()"></i-button>
                                  @if (textToCopy !== null) {
                                    <i-button styleClass="red me-3" [text]="'reset' | translate" (click)="reset()"></i-button>
                                  }
                                </div>
                              </div>
                              @if (textToCopy) {
                                <div class="alert alert-primary" [innerHtml]="textToCopy"></div>
                              }
                              <div class="d-flex align-items-center justify-content-center" style="overflow: auto">
                                <i-button [text]="'createCourrier.zoom+' | translate" styleClass="blue me-3" (click)="zoomIn()"></i-button>
                                <i-button [text]="'createCourrier.zoom-' | translate" styleClass="blue me-3" (click)="zoomOut()"></i-button>
                                <i-button [text]="'createCourrier.resetZoom' | translate" styleClass="blue" (click)="resetImage()"></i-button>
                              </div>
                              <div #cropContainer style="display: block; max-height: 80vh; overflow: auto">
                                @if (currentPageImageBase64) {
                                  <image-cropper
                                    [imageBase64]="currentPageImageBase64"
                                    [cropper]="cropperPosition"
                                    [maintainAspectRatio]="false"
                                    [cropperMinWidth]="1"
                                    [cropperMinHeight]="1"
                                    [imageQuality]="100"
                                    [transform]="transform"
                                    format="jpeg"
                                    (imageCropped)="imageCropped($event)"
                                    (cropperReady)="cropperReady($event)">
                                  </image-cropper>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      } @else {
                        @if (!convertedMail) {
                          <div>
                            <div class="col-12 alert alert-warning">{{ 'error.errorOccurredWhileDownloadingMailFile' | translate }}</div>
                          </div>
                        }
                        @if (convertedMail) {
                          <div class="col-12 colReader email-reader">
                            <div class="row">
                              <div class="col-12 d-flex justify-content-start">
                                <h4 class="custom-h4-title me-2">{{ 'createCourrier.from' | translate }}:</h4>
                                <div>{{ convertedMail?.sender.email }}</div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 d-flex justify-content-start">
                                <h4 class="custom-h4-title me-2">{{ 'createCourrier.to' | translate }}:</h4>
                                @for (r of convertedMail?.recipients; track r) {
                                  <div>{{ r?.email }}</div>
                                }
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 d-flex justify-content-start">
                                <h4 class="custom-h4-title me-2">{{ 'createCourrier.subject' | translate }}:</h4>
                                <div>{{ convertedMail?.subject }}</div>
                              </div>
                            </div>
                            <div class="iframe__container">
                              <iframe id="file4ReaderIframe" [srcdoc]="convertedMail?.bodyHtml" title=""></iframe>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              } @else {
                <div class="w-100 h-100">
                  <div class="d-flex justify-content-center align-items-center text-center overflow-100">
                    <div class="noFile">
                      <i class="bi bi-file-earmark-excel noFile__icon"></i>
                      <h1 class="custom-h1-title mb-2 border-0">{{ 'createCourrier.noFileAdded' | translate }}</h1>
                      <p>{{ 'createCourrier.addFileOrLinkMail' | translate }}</p>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @case ('fileViewer') {
            <div>
              <div class="templateChoice w-100 h-100">
                @if (currentFile || convertedMail) {
                  <div class="row">
                    @if (!isEmailFile) {
                      <div class="col-12 colReader">
                        @if (!showOCR) {
                          <div>
                            @if (
                              currentFile?.extension &&
                              currentFile?.extension.toLowerCase() !== 'rtf' &&
                              currentFile?.extension.toLowerCase() !== 'txt' &&
                              currentFile?.extension.toLowerCase() !== 'pdf' &&
                              currentFile?.extension.toLowerCase() !== 'docx'
                            ) {
                              <span>
                                <i-viewer [file]="currentFile"> </i-viewer>
                              </span>
                            }
                            @if (
                              currentFile?.extension &&
                              (currentFile?.extension.toLowerCase() === 'rtf' ||
                                currentFile?.extension.toLowerCase() === 'txt' ||
                                currentFile?.extension.toLowerCase() === 'docx')
                            ) {
                              <span>
                                <app-reader [currentFile]="cFile"></app-reader>
                              </span>
                            }
                            @if (currentFile?.extension && currentFile?.extension.toLowerCase() === 'pdf') {
                              <span>
                                @if (currentFile) {
                                  <ngx-extended-pdf-viewer
                                    [src]="currentFile?.src"
                                    height="100vh"
                                    [zoom]="'auto'"
                                    [showFindButton]="true"
                                    [showPagingButtons]="true"
                                    [showZoomButtons]="true"
                                    [showPresentationModeButton]="true"
                                    [showOpenFileButton]="false"
                                    [showPrintButton]="false"
                                    [showDownloadButton]="false"
                                    [showSecondaryToolbarButton]="true"
                                    [showRotateButton]="true"
                                    [showHandToolButton]="true"
                                    [handTool]="false"
                                    [showScrollingButton]="true"
                                    [showSpreadButton]="false"
                                    [showPropertiesButton]="true"
                                    [customToolbar]="additionalButtons"
                                    [(page)]="currentPage"
                                    (pageRendered)="pageRendered($event)">
                                  </ngx-extended-pdf-viewer>
                                }
                                <ng-template #additionalButtons>
                                  <div id="toolbarViewer">
                                    <div id="toolbarViewerLeft">
                                      <pdf-toggle-sidebar></pdf-toggle-sidebar>
                                      <div class="toolbarButtonSpacer"></div>
                                      <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
                                      <pdf-paging-area></pdf-paging-area>
                                    </div>
                                    <div id="toolbarViewerRight">
                                      <pdf-presentation-mode></pdf-presentation-mode>
                                      <pdf-select-tool></pdf-select-tool>
                                      <pdf-rotate-page></pdf-rotate-page>
                                      <pdf-hand-tool></pdf-hand-tool>
                                      @if (currentFile) {
                                        <button
                                          type="button"
                                          class="toolbarButton new-tab hiddenMediumView"
                                          [title]="'createCourrier.fileOCR' | translate"
                                          (click)="openOCR()">
                                          <img src="./assets/img/decoration/ocr.png" alt="" />
                                        </button>
                                      }
                                      <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
                                    </div>
                                    <pdf-zoom-toolbar></pdf-zoom-toolbar>
                                  </div>
                                </ng-template>
                              </span>
                            }
                          </div>
                        }
                        @if (showOCR) {
                          <div>
                            <div class="d-flex align-items-center justify-content-between">
                              <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'createCourrier.documentOCR' | translate }}</h5>
                              <div class="d-flex align-items-center mb-2">
                                <i-button styleClass="red me-3" [text]="'createCourrier.stopOCR' | translate" (click)="showOCR = false"></i-button>
                                <i-button styleClass="blue me-3" [text]="'createCourrier.ocr' | translate" (click)="startOCR()"></i-button>
                                @if (textToCopy !== null) {
                                  <i-button styleClass="red me-3" [text]="'reset' | translate" (click)="reset()"></i-button>
                                }
                              </div>
                            </div>
                            @if (textToCopy) {
                              <div class="alert alert-primary" [innerHtml]="textToCopy"></div>
                            }
                            <div class="d-flex align-items-center justify-content-center" style="overflow: auto">
                              <i-button [text]="'createCourrier.zoom+' | translate" styleClass="blue me-3" (click)="zoomIn()"></i-button>
                              <i-button [text]="'createCourrier.zoom-' | translate" styleClass="blue me-3" (click)="zoomOut()"></i-button>
                              <i-button [text]="'createCourrier.resetZoom' | translate" styleClass="blue" (click)="resetImage()"></i-button>
                            </div>
                            <div #cropContainer style="display: block; max-height: 80vh; overflow: auto">
                              @if (currentPageImageBase64) {
                                <image-cropper
                                  [imageBase64]="currentPageImageBase64"
                                  [cropper]="cropperPosition"
                                  [maintainAspectRatio]="false"
                                  [cropperMinWidth]="1"
                                  [cropperMinHeight]="1"
                                  [imageQuality]="100"
                                  [transform]="transform"
                                  format="jpeg"
                                  (imageCropped)="imageCropped($event)"
                                  (cropperReady)="cropperReady($event)">
                                </image-cropper>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="col-12 colReader email-reader">
                        <div class="row">
                          <div class="col-12 mb-3 d-flex justify-content-center align-items-center">
                            <p-dropdown
                              [options]="encodage"
                              [(ngModel)]="encoding"
                              [placeholder]="'createCourrier.selectEncoding' | translate"
                              (onChange)="changeEncodage()"
                              [showClear]="true"
                              [filter]="true">
                            </p-dropdown>
                          </div>
                          <div class="col-12 d-flex justify-content-start">
                            <h4 class="custom-h4-title me-2">{{ 'createCourrier.from' | translate }}:</h4>
                            <div>{{ convertedMail?.sender.email }}</div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 d-flex justify-content-start">
                            <h4 class="custom-h4-title me-2">{{ 'createCourrier.to' | translate }}:</h4>
                            @for (r of convertedMail.recipients; track r) {
                              <div>{{ r?.email }}</div>
                            }
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 d-flex justify-content-start">
                            <h4 class="custom-h4-title me-2">{{ 'createCourrier.subject' | translate }}:</h4>
                            <div>{{ convertedMail?.subject }}</div>
                          </div>
                        </div>
                        <div class="iframe__container">
                          <iframe id="file4ReaderIframe" [srcdoc]="convertedMail?.bodyHtml" title=""></iframe>
                        </div>
                      </div>
                    }
                    <!-- $$ EMAIL $$$$$$$$$$$$$$$$$$$$ -->
                  </div>
                } @else {
                  <div class="w-100 h-100">
                    <div class="d-flex justify-content-center align-items-center text-center overflow-100">
                      <div class="noFile">
                        <i class="bi bi-file-earmark-excel noFile__icon"></i>
                        <h1 class="custom-h1-title mb-2 border-0">{{ 'createCourrier.noFileAdded' | translate }}</h1>
                        <p>{{ 'createCourrier.addFileOrLinkMail' | translate }}</p>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <ng-template #noFile>
                <div class="w-100 h-100">
                  <div class="d-flex justify-content-center align-items-center text-center overflow-100">
                    <div class="noFile">
                      <i class="bi bi-file-earmark-excel noFile__icon"></i>
                      <h1 class="custom-h1-title mb-2 border-0">{{ 'createCourrier.noFileAdded' | translate }}</h1>
                      <p>{{ 'createCourrier.addFileOrLinkMail' | translate }}</p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          }
        }
      </div>
    </section>
  }

  <!-- End Editor Mode  -->
</div>
